/* unplugin-vue-components disabled */import script from "./DuplicateTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DuplicateTable.vue?vue&type=script&setup=true&lang=ts"

import "./DuplicateTable.vue?vue&type=style&index=0&id=3d2333f8&scoped=true&lang=less"
import "./DuplicateTable.vue?vue&type=style&index=1&id=3d2333f8&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d2333f8"]])

export default __exports__